// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h3 {
    position: relative;
    top: -2px;
    left: 4px;
    display: inline;
    font-size: 1.5rem;
    color: #5E0066;
    font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Tests/test-route/test-route.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB","sourcesContent":["h3 {\n    position: relative;\n    top: -2px;\n    left: 4px;\n    display: inline;\n    font-size: 1.5rem;\n    color: #5E0066;\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
